import { Box, Button, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useRef, useState } from 'react';
import { CustomLabel, DataTable, TraceDialog } from '../../../common';


import { BackButton } from '../../../common/BackButton';

import { Card } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../_metronic';
import { Loadable } from '../../../common';


import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import { asDate } from '../../../util/date';
import { asDollarsWithZero } from '../../../util/format';
import { AdvancedTrace } from '../../ClaimAnalysisPage/ClaimViewPage/AdvancedTrace';
import { PocketCostDialog } from '../../claimEstimatorPage/estimationsResultPage/PocketCostDialog';
import { ActiveFacilitiesDialog } from './ActiveFacilitiesDialog';
import { CONTRACTED_SERVICE_PROFESSIONAL } from '../../../store/constants/contract';
import { useData } from '@pure-ptr/react';
import { getPlaceOfServiceCodes } from '../../../store/api/claimAnalysis';

const useStyles = makeStyles(theme => ({
    background: {
        background: 'white',
    },
    addressCardStyles:{
        border:'none',display:'none'
    },
    disclaimerTextStyle:{
        display:'inline-block'

    },
    printOnlyCard: {
    display: 'none'
    },
    disclaimerCard:{
        border:'none',display:'none'
    },
    signaturesCard:{
        border:'none',justifyContent:'center',display:'none'

    },
    hideInPrint: {
    '@media print': {
        display: 'none'
        }
    },
    stickyClaimCard: {
        position: 'sticky',
        top: -16,
        zIndex: 20,
    },
    signaturesCardContainer:{
        display:'flex',marginBottom:'20px',columnGap:'10px'
    },
    signaturesCardBox:{
        width:'350px',display:'flex',columnGap:'5px'
    },
    signaturesCardText:{
        minWidth:'max-content',position:'relative',top:'5px'
    },
    signaturesField:{
        width:'100%',borderBottom:'1px solid'
    },
    signaturesDateFieldContainer:{
        width:'140px',display:'flex',columnGap:'5px'
    },
    signaturesDateFieldText:{
        position:'relative',top:'5px'
    },
    signaturesDate:{
        width:'100%',borderBottom:'1px solid'
    }
}));

function EstimateHistoryDetailsPage({  fields, order,sort, sections,data,estimatorId,getEstimatePending,getFacilitiesPending,
    facilitiesData,getBrandingDetailsPending, brandingDetails,outPocket, payerIdMappingSettingsFlag, filteredData, chargeLevelSections, 
    actions: { setSort, setOrder,getEstimateById,
        getFacilities ,getBrandingDetails} }) {
    const [isAnalysisTraceOpen, setAnalysisTraceOpen] = useState(false);
    const [isAdvancedTraceOpen, setAdvancedTraceOpen] = useState(false);
    const [haveActiveFacilities, setHaveActiveFacilities] = useState(false);
    const [isPocketCostDialogOpen, setPocketCostDialog] = useState(false);
    const [selectedFacility, setSelectedFacility] = useState(null);

    const componentRef = useRef();
    const classes = useStyles();    

    const { data:placeOfServiceCodes, isPending, error } = useData( async () => {        
        const placeOfServiceCodes = await getPlaceOfServiceCodes();
        return placeOfServiceCodes
    }, []);

    useEffect(() => {
        getEstimateById(estimatorId)
    }, [getEstimateById]);

    useEffect(() => {
        getFacilities()
    }, [getFacilities]);

    useEffect(() => {
        getBrandingDetails(null);
    }, [getBrandingDetails]);

    

    const hoverData = (rowData) => {
        const hoverColumns = new Map();

        const pxCodeColumns = [
            {
                label: "",
                data: rowData?.pxCodeDescription ?? ''
            }
        ];
        const revCodeColumns = [
            {
                label: "",
                data: rowData?.revCodeDescription ?? ''
            }
        ];

        hoverColumns.set('pxCode', pxCodeColumns);
        hoverColumns.set('revCode', revCodeColumns);

        return hoverColumns;
    }


    function handleTraceOpen() {

        if (sections && sections.length > 0) {
            setAdvancedTraceOpen(true);
        } else {
            setAnalysisTraceOpen(true);
        }
    }
    function handleTraceClose() {
        setAnalysisTraceOpen(false);
    }

    const handleFacilityBasedPrint = () => {
        addRemoveTextDecoration(true,componentRef)
        handlePrint();
        addRemoveTextDecoration(false,componentRef)
        
    }

    function handleStyleForPrint() {
        if(facilitiesData?.length>1)
        {   
            setHaveActiveFacilities(true)
        }
        else if(facilitiesData?.length===1)
        {
            getBrandingDetails(facilitiesData[0]?.id,handleFacilityBasedPrint)
        }
        else {
            getBrandingDetails(null,handleFacilityBasedPrint)

        }
    }

    

    const addRemoveTextDecoration = (isRemove, componentRef) => {
        const elements = [
            { id: 'print-logo-img', styles: { display: isRemove ? 'block' : 'none' } },
            { id: 'card-1', classes: 'mx-5' },
            { id: 'card-2', classes: 'mx-5' },
            { id: 'card-3', classes: 'mx-5', styles: { display: isRemove ? 'grid' : 'none' } },
            { id: 'card-4', classes: 'mx-5', styles: { display: isRemove ? 'block' : 'none' } },
            { id: 'card-5', classes: 'mx-5', styles: { display: isRemove ? 'block' : 'none' } },
            { id: 'card-6', classes: 'mx-5', styles: { display: isRemove ? 'block' : 'none' } },
        ];
        elements.forEach(({ id, classes, styles }) => {
            const element = document.getElementById(id);
            if (!element) return;
            if (classes) {
                isRemove ? element.classList.add(classes) : element.classList.remove(classes);
            }
            if (styles) {
                Object.assign(element.style, styles);
            }
        });
        const links = componentRef.current.querySelectorAll('.datatable tr td:nth-child(2) a, .datatable tr td:nth-child(3) a');
        links.forEach(link => {
            link.style.textDecoration = isRemove ? 'none' : 'underline';
            link.style.color = isRemove ? 'black' : '#2739c1';
        });
     };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handleActiveFacilityDialogClose = () => {

        setHaveActiveFacilities(false)
    }
    function handlePocketCostOpen() {
        setPocketCostDialog(true);
    }
    function handlePocketCostClose() {
        setPocketCostDialog(false);
    }

    function orderCharges(data) {
        if(!data || data.length === 0) return []
        // Check if any item has displayGridKey property is null it means no grouping needed it is legacy data need to return as is
        const hasNullDisplayGridKey = data.filter(item => item.displayGridKey === null || item.displayGridKey === undefined);
        if (hasNullDisplayGridKey.length > 0) {
            return data;
        }
        // Group all charges by displayGridKey
        const grouped = data.reduce((acc, item) => {
            const key = item.displayGridKey || item.primaryId;
            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, {});

        const ordered = [];

        // Traverse through each group
        for (const key in grouped) {
            const group = grouped[key];
            // Find parent
            const parent = group.find((item) => item.isPrimaryCpt === true);
            if (parent) {
                ordered.push(parent);
                // Find children and append
                const children = group.filter(
                    (item) => item.isPrimaryCpt === false
                );
                ordered.push(...children);
            }
        }

        return ordered;
    }



    let chargeEstCreated = data?.chargeEstimations?.map((item) => ({
        ...item,
        perUnitChargeAmount: item?.perUnitCharge, // from API
        totalCharges: item?.totalCharges          // from API
    }))

    const finalCptCode = orderCharges(chargeEstCreated);

    const isSelfPayWithContract =
    data?.isSelfPayEnabled &&
    brandingDetails?.isSelfPayEnabled &&
    brandingDetails?.selfPayContractId &&
    brandingDetails?.selfPayContractId > 0;

    const isSelfPayWithoutContract =
        data?.isSelfPayEnabled &&
        brandingDetails?.isSelfPayEnabled &&
        (!brandingDetails?.selfPayContractId || brandingDetails?.selfPayContractId === 0);

    const updatedFields = React.useMemo(() => {
        let updated = [...(fields || [])];

        if (isSelfPayWithoutContract) {
            updated = updated.filter(field => field?.id !== 'estimatedPayment');
        }

        if (isSelfPayWithContract) {
            updated = updated.map(field =>
                field?.id === 'estimatedPayment'
                    ? { ...field, label: 'Self Pay' }
                    : field
            );
        }

        return updated;
    }, [fields, isSelfPayWithoutContract, isSelfPayWithContract]);

    return (
        <Box className={classes.background}>
        <Loadable loading={getEstimatePending || getFacilitiesPending || getBrandingDetailsPending}>
          
                <DialogTitle>
                    <Grid container alignItems='center'>
                        <Grid item xs={5}>
                            <Typography variant="h6">Estimation History</Typography>
                        </Grid>
                        <Grid xs={6}>
                            <Grid container className='justify-content-end'>
                           {outPocket && data && !data?.isSelfPayEnabled && (
                                    <Button
                                        onClick={handlePocketCostOpen}
                                        variant='outlined'
                                        color="primary"
                                    >
                                        Out of Pocket Cost
                                    </Button>
                                )}
                                <Button onClick={handleTraceOpen}
                                    className='ml-2'
                                    variant='outlined'
                                    color="primary">
                                    Analysis Trace
                                </Button>
                                <Button
                                    onClick={handleStyleForPrint}
                                    className='ml-2'
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<PrintIcon />}
                                >
                                    Print
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={1} className='text-right'>
                            <BackButton text='Back' defaultRoute="/estimator/history" />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers  sx={{maxHeight: '80vh',overflowY: 'auto' }}>
                    <Grid xs={12} ref={componentRef}>
                        <div id='print-logo-img' style={{ display: 'none' }} className="kt-login__logo text-center my-5">
                            <a href="/#">
                                
                                <img alt="logo" 
                                
                                // src={toAbsoluteUrl("/media/logos/logo-light.v3.png?v=4")}
                                
                                src={brandingDetails?.logoPath ? (brandingDetails?.usePricerLogo ? 
                                    `https://${brandingDetails?.pricerBucket}.s3.amazonaws.com/${brandingDetails?.logoPath}?q=${Date.now()}` :
                                    toAbsoluteUrl(`/${brandingDetails?.logoPath}?q=${Date.now()}`)) 
                                    : toAbsoluteUrl("/media/logos/logo-light.v3.png?v=4")}
                                />
                            </a>
                        </div>
                        <Card id='card-1' className={classes.stickyClaimCard}>
                            <Card.Header as="h5">Claim Estimation</Card.Header>
                            <Card.Body>
                                <Grid container md={12} className='px-3 py-2'>
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Estimation Id" data={data?.estimationId} />
                                    </Grid>
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Patient Name" data={`${data?.patientFName || ''} ${data?.patientLName || ''}`} />
                                    </Grid>
                                   
                                       {payerIdMappingSettingsFlag &&!data?.isSelfPayEnabled &&data?.estimatorPayer ? (
                                        <Grid item xs={5} className='py-1'>
                                            <CustomLabel
                                                label="Payer Name"
                                                data={`${data?.estimatorPayer?.payerName} (${data?.estimatorPayer?.payerId})` || ''}
                                            />
                                        </Grid>
                                    ) : (
                                        !data?.isSelfPayEnabled && (
                                            <Grid item xs={5} className='py-1'>
                                                <CustomLabel
                                                    label="Contract"
                                                    data={data?.contract?.name || ''}
                                                />
                                            </Grid>
                                        )
                                    )}
                                        
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Claim Type" data={data?.claimType} />
                                    </Grid>
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Total Claim Amount" data={asDollarsWithZero(data?.claimAmount)} />
                                    </Grid>
                                  {!isSelfPayWithoutContract && (
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel
                                            label={isSelfPayWithContract ? "Self Pay Amount" : "Allowable"}
                                            data={asDollarsWithZero(data?.estimatedClaimAmount)}
                                        />
                                    </Grid>
                                )}
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Anticipated Service Date" data={asDate(data?.admitionDate)} />
                                    </Grid>
                                   {data?.isSelfPayEnabled && !isSelfPayWithContract && (
                                    <Grid item xs={5} className='py-1'>
                                        <CustomLabel label="Self Pay Amount" data={asDollarsWithZero(data?.selfPayAmount)}/>
                                    </Grid>
                                    )}
                                    { data?.claimType === CONTRACTED_SERVICE_PROFESSIONAL &&
                                        <Grid item xs={5} className='py-1'>
                                            <CustomLabel label="Place Of Service" data={placeOfServiceCodes?.find(pos=>pos.code == data?.placeOfServiceCode)?.name  || ''} />
                                        </Grid>
                                    }
                                    {Boolean(data?.copay !== null && data?.remainingDeductible !== null && data?.coInsurancePercent !== null && data?.maxOutOfPocket) &&
                                        <Grid item xs={5} className='py-1'>
                                            <CustomLabel label="Out of the Pocket" data={asDollarsWithZero(data?.outOfPocketAmount)} />
                                        </Grid>
                                    }
                                    {Boolean((data?.copay !== null && data?.remainingDeductible !== null && data?.coInsurancePercent !== null && data?.maxOutOfPocket ) || ( data?.isSelfPayEnabled && data?.outOfPocketAmount != null)) && brandingDetails?.isPromptPayEnabled && 
                                    (<Grid item xs={12} className={`py-2 ${classes.hideInPrint}`} sx={{ mt: 3 }}>
                                            <Typography>
                                                 <strong>Note:</strong>{" "}
                                                {selectedFacility?.name || "This facility"} offers a{" "}
                                                {brandingDetails?.promptPayPercentage}% prompt pay discount if full payment is made within{" "}
                                                {brandingDetails?.promptPayDays} days.
                                            </Typography>

                                            <Typography className='mt-1'>
                                                <strong>Calculation: </strong>
                                                {asDollarsWithZero(data?.outOfPocketAmount)} -{" "}
                                                {brandingDetails?.promptPayPercentage}% ={" "}
                                                {asDollarsWithZero(data?.percentagePayAmount)}
                                            </Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </Card.Body>
                        </Card>
                        <Card className='mt-4' id='card-2'>
                            <Card.Header as="h5">Charge Estimation</Card.Header>
                            <Card.Body>
                                <DataTable
                                    fields={updatedFields}
                                    data={finalCptCode}
                                    order={order}
                                    onOrder={setOrder}
                                    sort={sort}
                                    onSort={setSort}
                                    displayTotal={true}
                                    hoverData={hoverData}
                                />


                            </Card.Body>
                        </Card>
                        <Card className={`mt-4 ${classes.signaturesCard}`} id='card-3'>
                            {brandingDetails?.signatureLabelList?.map((item)=>
                            <Box className={`${classes.signaturesCardContainer}`} >
                                <Box className={`${classes.signaturesCardBox}`}>
                                    <Typography className={`${classes.signaturesCardText}`}>
                                        {item}
                                    </Typography>
                                    <Box className={`${classes.signaturesField}`} />
                                </Box>
                                <Box className={`${classes.signaturesDateFieldContainer}`} >
                                <Typography className={`${classes.signaturesDateFieldText}`} >
                                    Date</Typography>
                                    <Box className={`${classes.signaturesDate}`}/>
                                </Box>
                            </Box>)
                        }


                        </Card>
                        {Boolean((data?.copay !== null && data?.remainingDeductible !== null && data?.coInsurancePercent !== null && data?.maxOutOfPocket ) || ( data?.isSelfPayEnabled && data?.outOfPocketAmount != null)) && brandingDetails?.isPromptPayEnabled 
                        && (
                        <Card className={`mt-4 ${classes.printOnlyCard}`} id='card-6'  style={{ border: 'none', boxShadow: 'none', background: 'transparent' }}>
                            <Card.Body>
                               <Typography>
                                    {selectedFacility?.name || facilitiesData?.[0]?.name || 'Facility'} offers a {brandingDetails?.promptPayPercentage}% prompt pay discount if full payment is made within {brandingDetails?.promptPayDays} days.
                                </Typography>

                                <Typography className='mt-2'>
                                    <strong>Calculation: </strong>
                                    {asDollarsWithZero(data?.outOfPocketAmount)} -{" "}
                                    {brandingDetails?.promptPayPercentage}% ={" "}
                                    {asDollarsWithZero(data?.percentagePayAmount)}
                                </Typography>
                            </Card.Body>
                        </Card>
                    )}

                        <Card className={`mt-4 ${classes.disclaimerCard}`} id='card-4' >

                        <Typography><Box className={`ql-editor ${classes.disclaimerTextStyle}`} dangerouslySetInnerHTML={{ __html:
                                data?.claimType === 'OUTPATIENT'
                                ? brandingDetails?.outpatientDisclaimer
                                : data?.claimType === 'PROFESSIONAL'
                                ? brandingDetails?.professionalDisclaimer
                                : data?.claimType === 'INPATIENT'
                                ? brandingDetails?.inpatientDisclaimer
                                : ''
                                }} />
                         </Typography>
                        </Card>


                        <Card className={`mt-4 ${classes.addressCardStyles}`} id='card-5' >



                        <Grid container alignItems='center'>
                        <Grid item xs={6}>
                            <Typography>
                                {brandingDetails?.address} , 
                                {brandingDetails?.streetAddress && <><br/>{brandingDetails?.streetAddress}</>}
                                {brandingDetails?.city && <><br/>{brandingDetails?.city},{brandingDetails?.state} {brandingDetails?.zip}<br/></>}    
                                {brandingDetails?.phone}
                            </Typography>
                        </Grid>
                        <Grid xs={6}>
                            <Grid container className='justify-content-end'>

                            <Typography>Date Time: { asDate()}</Typography>

                               
                            </Grid>
                        </Grid>
                        
                    </Grid>

                    </Card>

                    </Grid>
                </DialogContent>
        </Loadable>
        <TraceDialog open={isAnalysisTraceOpen} handleClose={handleTraceClose} traces={data?.analysisTraces} />
        <AdvancedTrace sections={sections} isTraceOpen={isAdvancedTraceOpen} setTraceOpen={setAdvancedTraceOpen} title={data?.estimationId} chargeLevelSections={chargeLevelSections} />
        <ActiveFacilitiesDialog open={haveActiveFacilities} handleClose={handleActiveFacilityDialogClose} facilities={facilitiesData} getBrandingDetails={getBrandingDetails} getBrandingDetailsPending={getBrandingDetailsPending} handlePrint={(facilityId) => {
            const facility = facilitiesData.find(f => f.id === facilityId);
            setSelectedFacility(facility);
            getBrandingDetails(facilityId, handleFacilityBasedPrint);
        }}/>

        <PocketCostDialog open={isPocketCostDialogOpen} handleClose={handlePocketCostClose} estimationId={data?.estimationId} claimAmount={data?.estimatedClaimAmount} />

        </Box>
    )
}

export default EstimateHistoryDetailsPage